<template>
  <div class="container">
    <div class="banner">
<!--      <div class="title">知谱教研</div>-->
      <div class="slogan"> 创新教研形态 加强教学研究 共享优质资源</div>
    </div>
    <div class="vroom">
      <div class="vroom-bg">
        <div class="vroom-title">
          <img src="../../assets/images/work_news/t2_left.png">
          <div>虚拟教研室</div>
          <img src="../../assets/images/work_news/t2_right.png">
        </div>
        <div class="vroom-list">
          <div class="list" data-v-0e1f72d4="">
            <div class="item" data-v-0e1f72d4="">人工智能专业虚拟教研室</div>
            <div class="item" data-v-0e1f72d4="">自然语言处理课程群虚拟教研室</div>
            <div class="item" data-v-0e1f72d4="">知识工程课程群教学虚拟教研室</div>
            <div class="item" data-v-0e1f72d4="">机器学习与算法课程群虚拟教研室</div>
            <div class="item" data-v-0e1f72d4="">脑认知科学课程群虚拟教研室</div>
            <div class="item" data-v-0e1f72d4="">人工智能伦理与治理课程群虚拟教研室</div>
            <div class="item" data-v-0e1f72d4="">人工智能实验虚拟教研室</div>
            <div class="item" data-v-0e1f72d4="">深度学习课程群虚拟教研室</div>
            <div class="item" data-v-0e1f72d4="">模式识别课程群虚拟教研室</div>
            <div class="item" data-v-0e1f72d4="">燃气轮机专业课程群虚拟教研室</div>
            <div class="item" data-v-0e1f72d4="">燃气轮机材料课程虚拟教研室</div>
            <div class="item" data-v-0e1f72d4="">病毒学专业虚拟教研室</div>
            <div class="item" data-v-0e1f72d4="">病毒学总论课程虚拟教研室</div>
            <div class="item" data-v-0e1f72d4="">医学病毒学课程虚拟教研室</div>
            <div class="item" data-v-0e1f72d4="">动物病毒学课程虚拟教研室</div>
            <div class="item" data-v-0e1f72d4="">植物病毒学课程虚拟教研室</div>
            <div class="item" data-v-0e1f72d4="">昆虫病毒学课程虚拟教研室</div>
          </div>
          <div class="list" data-v-0e1f72d4="">
            <div class="item" data-v-0e1f72d4="">微生物病毒学课程虚拟教研室</div>
            <div class="item" data-v-0e1f72d4="">病毒学实验技术课程虚拟教研室</div>
            <div class="item" data-v-0e1f72d4="">国土空间规划专业建设虚拟教研室</div>
            <div class="item" data-v-0e1f72d4="">多学科交叉的国土空间规划虚拟教研室</div>
            <div class="item" data-v-0e1f72d4="">国土空间治理专业建设虚拟教研室</div>
            <div class="item" data-v-0e1f72d4="">国土空间规划基础课程群虚拟教研室</div>
            <div class="item" data-v-0e1f72d4="">国土空间规划相关知识课程群虚拟教研室</div>
            <div class="item" data-v-0e1f72d4="">国土空间规划编制实践课程虚拟教研室</div>
            <div class="item" data-v-0e1f72d4="">国土空间使用与管理虚拟教研室</div>
            <div class="item" data-v-0e1f72d4="">国土空间发展与治理课程群虚拟教研室</div>
            <div class="item" data-v-0e1f72d4="">数字国土空间构成课程群虚拟教研室</div>
            <div class="item" data-v-0e1f72d4="">新型教材暨数字教学法研究虚拟教研室</div>
            <div class="item" data-v-0e1f72d4="">面向智慧教育的知识图谱研究与构建虚拟教研室</div>
            <div class="item" data-v-0e1f72d4="">数字化转型下的教研创新虚拟教研室</div>
            <div class="item" data-v-0e1f72d4="">智能化教学创新虚拟教研室</div>
            <div class="item" data-v-0e1f72d4="">虚拟现实技术及应用虚拟教研室</div>
          </div>
        </div>
      </div>
    </div>
    <div class="my-room">
      <div class="my-room-title">
        <img src="../../assets/images/work_news/t2_left.png">
        <div>开通我的教研室</div>
        <img src="../../assets/images/work_news/t2_right.png">
      </div>
      <div class="my-room-list">
        <div class="item item1">
          <div class="title" data-v-0e1f72d4="">创新教研形态</div>
          <div class="content" data-v-0e1f72d4="">
            充分运用信息技术，探索突破时空限制、高效便捷、形式多样、“线上+线下”结合的教师教研模式，形成基层教学组织建设管理的新思路、新方法、新范式，充分调动教师的教学活力，厚植教师教学成长沃土。
          </div>
        </div>
        <div class="item item2">
          <div class="title" data-v-0e1f72d4="">构建知识图谱</div>
          <div class="content" data-v-0e1f72d4="">
            为虚拟教研室成员提供简单、易操作的编辑工具，构建全面多层级的学科领域知识图谱，构建过程中，既融入人工智能技术，实现对上传文本内容智能识别、深度挖掘，也为成员提供团队在线协作功能，凝聚多方智慧协同搭建完成知识图谱。
          </div>
        </div>
        <div class="item item3">
          <div class="title" data-v-0e1f72d4="">共建优质资源</div>
          <div class="content" data-v-0e1f72d4="">
            虚拟教研室成员在充分研究交流的基础上，协同共建人才培养方案、教学大纲，以知识图谱为基础，汇聚教学视频、电子课件、习题试题、教学案例、实验项目、实训项目、数据集等教学资源，形成优质共享的教学资源库与示范课程。
          </div>
        </div>
        <div class="item item4">
          <div class="title" data-v-0e1f72d4="">加强教学研究</div>
          <div class="content" data-v-0e1f72d4="">
            依托虚拟教研室，推动教师加强对专业建设、课程实施、教学内容、教学方法、教学手段、教学评价等方面的研究探索，提升教学研究的意识，凝练和推广研究成果。
          </div>
        </div>

      </div>
    </div>

    <div class="apply">
      <div class="btn" @click="openWinApply">
        <img src="../../assets/images/work_news/apply.png">
        <div >申请试用</div>
      </div>
    </div>

    <div class="app-down" data-v-f348d130="" data-v-0e1f72d4="">
      <div class="app-down-title" data-v-f348d130="">
        <div>知谱教研应用下载</div>
        <img src="../../assets/images/work_news/app-dowm.png">
        <div class="connect-btn" @click="openWinConnect">联系我们</div>
      </div>
      <div class="app-down-list" data-v-f348d130="">
        <div class="app-down-item" data-v-f348d130="" @click="downloadFile(pathObj.windows)"><!---->
          <img src="data:image/png;base64,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" alt="" data-v-f348d130="">
          <div class="name" data-v-f348d130="">Windows</div>
        </div>
        <div class="app-down-item" data-v-f348d130="" @click="downloadFile(pathObj.mac)"><!---->
          <img src="data:image/png;base64,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" alt="" data-v-f348d130="">
          <div class="name" data-v-f348d130="">Mac</div>
        </div>
        <div class="app-down-item" data-v-f348d130="">
          <img src="data:image/png;base64,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" alt="" data-v-f348d130="">
<!--          <img class="code" src="../../assets/images/work_news/android.png">-->
          <vue-qr class="code" :text="pathObj.android" :size="400" ></vue-qr>
          <img class="logo" src="../../assets/images/work_news/app_logo.png">
          <div class="name" data-v-f348d130="">Android</div>
        </div>
        <div class="app-down-item" data-v-f348d130="">
          <img src="data:image/png;base64,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" alt="" data-v-f348d130="">
<!--          <img class="code" src="../../assets/images/work_news/ios.png">-->
          <vue-qr class="code" :text="pathObj.apple" :size="400"></vue-qr>
          <img class="logo" src="../../assets/images/work_news/app_logo.png">
          <div class="name" data-v-f348d130="">iPhone</div>
        </div>
      </div>
    </div>
    <div class="footer-margin"></div>
    <div class="win-apply" :style="winApply.show == true ? 'display: block' : 'display: none'">
      <div class="win-apply-bg"></div>
      <div class="win-apply-panel">
        <div class="win-apply-header">
          <div>申请试用</div>
          <img src="../../assets/images/work_news/btn_close.png" @click="closeWinApply">
        </div>
        <div class="win-apply-body">
          <div class="apply-form-item">
            <div class="apply-form-item-label"><span class="require">*</span>您的姓名</div>
            <div class="apply-form-item-input" :class="winApply.formValidate.name ? '': 'apply-form-item-input-err'">
              <input type="text" maxlength="10" v-model="winApply.formInfo.name" @blur="validate('name')">
              <div class="err">请输入姓名</div>
            </div>
          </div>
          <div class="apply-form-item">
            <div class="apply-form-item-label"><span class="require">*</span>所在单位</div>
            <div class="apply-form-item-input" :class="winApply.formValidate.org ? '': 'apply-form-item-input-err'">
              <input type="text" maxlength="30" v-model="winApply.formInfo.org" @blur="validate('org')">
              <div class="err">请输入单位</div>
            </div>
          </div>
          <div class="apply-form-item">
            <div class="apply-form-item-label"><span class="require">*</span>联系电话</div>
            <div class="apply-form-item-input" :class="winApply.formValidate.phone ? '': 'apply-form-item-input-err'">
              <input type="text" maxlength="20" v-model="winApply.formInfo.phone" @blur="validate('phone')">
              <div class="err">请输入手机号</div>
            </div>
          </div>
          <div class="apply-form-item">
            <div class="apply-form-item-label">详细信息</div>
            <div class="apply-form-item-input">
              <textarea v-model="winApply.formInfo.content" maxlength="200"></textarea>
            </div>
          </div>
        </div>
        <div class="win-apply-footer">
          <div class="win-apply-btn win-apply-btn-close" @click="closeWinApply">关闭</div>
          <div class="win-apply-btn win-apply-btn-confirm" @click="saveApply">确定</div>
        </div>
      </div>
    </div>
    <div class="win-connect" :style="winConnect.show == true ? 'display: block' : 'display: none'">
      <div class="win-connect-bg"></div>
      <div class="win-connect-panel">
        <div class="win-connect-header">
          <div>联系我们</div>
          <img src="../../assets/images/work_news/btn_close.png" @click="closeWinConnect">
        </div>
        <div class="win-connect-body">
          <div class="title">技术支持</div>
          <div class="content">知谱教研：400-806-6256</div>
          <div class="title">服务时间</div>
          <div class="content">工作日9:00-18:00</div>
          <div class="title">帮助文档：</div>
          <div class="content">
            <a href="/static/upload_template/知谱教研客户端操作手册.pdf" download>知谱教研客户端操作手册.pdf</a>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import vueQr from 'vue-qr'

export default {
  name: "Research",
  components: {
    vueQr
  },
  data () {
    return {
      winApply: {
        show: false,
        formInfo: {
          name: '',
          org: '',
          phone: '',
          content: ''
        },
        formValidate: {
          name: true,
          org: true,
          phone: true,
          content: true
        }
      },
      winConnect: {
        show: false
      },
      pathObj: {
        android: '',
        apple: '',
        windows: '',
        mac: ''
      }
    }
  },
  methods: {
    validate (v) {
      if (v === 'name') {
        this.winApply.formValidate.name = this.winApply.formInfo.name.trim().length !== 0
      } else if (v === 'org') {
        this.winApply.formValidate.org = this.winApply.formInfo.org.trim().length !== 0
      } else if (v === 'phone') {
        this.winApply.formValidate.phone = this.winApply.formInfo.phone.trim().length !== 0
      } else {
        this.winApply.formValidate.name = this.winApply.formInfo.name.trim().length !== 0
        this.winApply.formValidate.org = this.winApply.formInfo.org.trim().length !== 0
        this.winApply.formValidate.phone = this.winApply.formInfo.phone.trim().length !== 0
      }
      return this.winApply.formValidate.name && this.winApply.formValidate.org && this.winApply.formValidate.phone
    },
    openWinApply () {
      this.winApply = {
        show: true,
        formInfo: {
          name: '',
          org: '',
          phone: '',
          content: ''
        },
        formValidate: {
          name: true,
          org: true,
          phone: true,
          content: true
        }
      }
    },
    closeWinApply () {
      this.winApply.show = false
    },
    saveApply () {
      if (this.validate()) {
        this.$http.post('/allowany/research/', {
          category: 1,
          name: this.winApply.formInfo.name,
          org: this.winApply.formInfo.org,
          phone: this.winApply.formInfo.phone,
          content: this.winApply.formInfo.content
        }).then((data) => {
          if (data.id) {
            this.$parent.showMsg('操作成功！')
            this.closeWinApply()
          } else {
            this.$parent.showMsg('操作失败！')
          }
        })
      }
    },
    downloadFile (path) {
      if (path) {
        window.open(path)
      }
    },
    openWinConnect () {
      this.winConnect.show = true
    },
    closeWinConnect () {
      this.winConnect.show = false
    },
    getDownloadPath () {
      // this.$http.get('/get_research_download_path/').then((data) => {
      //   let jsonData = JSON.parse(data)
      //   if (jsonData.success) {
      //     this.pathObj.android = jsonData.data[0].downloadUrl
      //     this.pathObj.apple = jsonData.data[1].downloadUrl
      //     this.pathObj.windows = jsonData.data[2].downloadUrl
      //     this.pathObj.mac = jsonData.data[3].downloadUrl
      //   }
      //   console.log(this.pathObj)
      // })
      this.pathObj.android = 'https://zpjy.spacekg.com/vroom/zpjy/api/install/update/download?platform=android'
      this.pathObj.apple = 'https://zpjy.spacekg.com/vroom/zpjy/api/install/update/download?platform=ios'
      this.pathObj.windows = 'https://zpjy.spacekg.com/vroom/zpjy/api/install/update/download?platform=windows'
      this.pathObj.mac = 'https://zpjy.spacekg.com/vroom/zpjy/api/install/update/download?platform=mac'
    }
  },
  mounted() {
    this.getDownloadPath()
  }
}
</script>

<style lang="less" scoped>
.require {
  color: red;
}

.container {
  min-width: 1280px;
  margin-bottom: 100px;
  background-color: white;
}

.banner {
  height: 550px;
  background: url('../../assets/images/work_news/banner_bg.png') no-repeat;
  background-size: 100% 100%;
  color: #fff;
  display: flex;
  flex-direction: column;
  padding-left: 20vw;
  padding-top: 100px;
  font-family: PingFangSC-Medium, PingFang SC;
  background-position-y: -75px;
  background-color: #EDEFFF;

  .title {
    font-size: 70px;
    font-weight: 600;
    line-height: 99px;
    color: white;
    width: 900px;
  }

  .slogan {
    margin-top: 90px;
    font-weight: 500;
    //opacity: .5;
    font-size: 48px;
    //width: 900px;
  }
}

.vroom {
  background: linear-gradient(#EDEFFF, #FFFFFF);
  margin-top: -80px;
  display: none;
  .vroom-bg {
    background: url('../../assets/images/work_news/t2_bg.png') no-repeat;
    background-size: 1280px;
    background-position: 5% 60%;
    height: 772px;
    display: flex;
    flex-direction: column;
    justify-content: flex-start;
    align-items: center;
    .vroom-title {
      display: flex;
      justify-content: center;
      align-items: center;

      div {
        font-size: 30px;
        font-weight: 500;
        margin: 0 20px;
        color: #2c3e50;
      }

      img {
        width: 29px;
      }
    }
    .vroom-list {
      display: flex;
      flex-direction: row;
      justify-content: flex-end;
      align-items: flex-start;
      width: 100%;

      .list {
        margin: 50px 20px;
        font-size: 22px;
        color: #404042;
        font-weight: 400;
        display: flex;
        flex-direction: column;
        font-family: PingFangSC-Regular, PingFang SC;

        .item {
          margin-top: 12px;
          line-height: 22px !important;
          margin-bottom: 0px;
        }
      }
    }
  }
}

.my-room {
  min-width: 1280px;
  display: flex;
  flex-direction: column;
  justify-content: flex-start;
  align-items: center;
  //background-color: white;
  background: linear-gradient(#EDEFFF, #FFFFFF);
  .my-room-title {
    display: flex;
    justify-content: center;
    align-items: center;
    margin-bottom: 60px;

    div {
      font-size: 30px;
      font-weight: 500;
      margin: 0 20px;
      color: #2c3e50;
    }

    img {
      width: 29px;
    }
  }

  .my-room-list {
    width: 100%;
    display: flex;
    flex-direction: row;
    justify-content: space-around;

    .item {
      width: 280px;
      height: 360px;
      background-size: 280px 360px;

      .title {
        font-size: 26px;
        font-family: PingFangSC-Semibold, PingFang SC;
        font-weight: 600;
        color: #fff;
        text-align: center;
        padding: 25px;
        width: 230px;
        height: 30px;
      }

      .content {
        width: 200px;
        white-space: normal;
        font-size: 16px;
        color: #505053;
        padding: 30px 40px;
        line-height: 22px;

      }
    }

    .item1 {
      background-image: url("../../assets/images/work_news/register-1.png");
    }

    .item2 {
      background-image: url("../../assets/images/work_news/register-2.png");
    }

    .item3 {
      background-image: url("../../assets/images/work_news/register-3.png");
    }

    .item4 {
      background-image: url("../../assets/images/work_news/register-4.png");
    }
  }
}

.apply {
  min-width: 1280px;
  margin-top: 30px;
  width: 100%;
  height: 50px;
  display: flex;
  flex-direction: row;
  align-items: center;
  justify-content: center;
  background-color: white;

  .btn {
    width: 280px;
    padding: 6px;
    cursor: pointer;
    background: #0356ca;
    box-shadow: 0 4px 4px #edeffc;
    border-radius: 33px;
    opacity: .9;
    border: 1px solid #e0e1fc;
    color: #fff;
    font-weight: 500;
    font-size: 22px;
    text-align: center;
    display: flex;
    flex-direction: row;
    align-items: center;
    justify-content: center;
  }
}

.app-down {
  background-color: #EDEFFF;
  background-image: url("../../assets/images/work_news/app_down_bg.png");
  margin-top: 70px;
  padding: 110px 70px;
  .app-down-title {
    display: flex;
    flex-direction: row;
    justify-content: flex-start;
    align-items: center;
    font-size: 34px;
    font-family: PingFangSC-Semibold,PingFang SC;
    font-weight: 600;
    color: #0356ca;
    img {
      margin-left: 35px;
    }
    .connect-btn {
      margin-left: 35px;
      font-size: 20px;
      cursor: pointer;
    }
  }
  .app-down-list {
    margin-top: 50px;
    display: flex;
    flex-direction: row;
    justify-content: space-between;
    align-items: center;
    .app-down-item {
      width: 260px;
      height: 280px;
      background-color: white;
      border-radius: 5px;
      display: flex;
      flex-direction: column;
      align-items: center;
      justify-content: center;
      position: relative;
      .name {
        margin-top: 30px;
        font-size: 24px;
        color: #404042;
        font-weight: 400;
        font-family: PingFangSC-Regular,PingFang SC;
      }
      .code {
        position: absolute;
        left: 50%;
        top: 50%;
        transform: translate(-50%, -50%);
        width: 240px;
        display: none !important;
      }
      .logo {
        position: absolute;
        left: 50%;
        top: 50%;
        transform: translate(-50%, -50%);
        width: 45px;
        border-radius: 5px;
        display: none;
      }
    }
    .app-down-item:hover{
      box-shadow:1px 1px 20px #1890ff4d;
      .code {
        display: block !important;
      }
      .logo {
        display: block;
      }
    }
  }
}

.footer-margin {
  min-width: 1280px;
  background-color: #EDEFFF;
  width: 100%;
  height: 100px;
}

.win-apply {
  .win-apply-bg {
    position: fixed;
    left: 0;
    top: 0;
    //height: 100%;
    //width: 100%;
    bottom: 0;
    right: 0;
    background-color: black;
    opacity: .2;
    z-index: 2;
  }
  .win-apply-panel {
    position: fixed;
    left: 50%;
    top: 50%;
    transform: translate(-50%, -60%);
    width: 600px;
    height: 420px;
    background-color: white;
    border-radius: 5px;
    z-index: 2;
    .win-apply-header {
      display: flex;
      height: 60px;
      line-height: 60px;
      padding: 0px 22px;
      font-size: 18px;
      flex-direction: row;
      justify-content: space-between;
      align-items: center;
      color: #333333;
      img {
        width: 16px;
        height: 16px;
      }
    }
    .win-apply-body {
      height: 240px;
      padding: 30px 7px;
      .apply-form-item {
        display: flex;
        flex-direction: row;
        justify-content: center;
        align-items: flex-start;
        height: 52px;
        .apply-form-item-label {
          height: 32px;
          line-height: 32px;
          font-size: 15px;
          margin-right: 15px;
        }
        .apply-form-item-input {
          input {
            width: 345px;
            height: 32px;
            border-radius: 3px;
            border: 1px solid #CCCCCC;
          }
          textarea {
            width: 345px;
            height: 80px;
            border-radius: 3px;
            border: 1px solid #CCCCCC;
          }
          .err {
            display: none;
            color: red;
            font-size: 14px;
            line-height: 1;
          }
        }
        .apply-form-item-input-err {
          input {
            border: 1px solid red;
          }
          .err {
            display: block;
          }
        }
      }
    }
    .win-apply-footer {
      display: flex;
      flex-direction: row;
      justify-content: flex-end;
      padding: 0px 30px;
      .win-apply-btn {
        width: 60px;
        height: 32px;
        line-height: 32px;
        border-radius: 3px;
        text-align: center;
        margin-left: 15px;
      }
      .win-apply-btn-close {
        border: 1px solid #CCCCCC;
        color: #606267;
      }
      .win-apply-btn-confirm {
        background-color: #00a0e9;
        color: white;
      }
    }
  }
}

.win-connect {
  .win-connect-bg {
    position: fixed;
    left: 0;
    top: 0;
    bottom: 0;
    right: 0;
    background-color: black;
    opacity: .2;
    z-index: 2;
  }
  .win-connect-panel {
    position: fixed;
    left: 50%;
    top: 50%;
    transform: translate(-50%, -60%);
    width: 480px;
    height: 320px;
    background-color: white;
    border-radius: 5px;
    z-index: 2;
    .win-connect-header {
      display: flex;
      height: 60px;
      line-height: 60px;
      padding: 0px 22px;
      font-size: 18px;
      flex-direction: row;
      justify-content: space-between;
      align-items: center;
      font-weight: bolder;
      color: #333333;
      img {
        width: 16px;
        height: 16px;
      }
    }
    .win-connect-body {
      height: 120px;
      padding: 0px 22px;
      .title {
        font-size: 18px;
        font-weight: bolder;
      }
      .content {
        font-size: 16px;
        margin-bottom: 15px;
        color: #333333;
        a {
          color: blue;
        }
      }
    }
  }
}

</style>
